













































import {Component, Vue, Config, BasePage} from '@/common';
import cuspreEdit from './components/cuspreEdit.vue';
import {TwTable} from '@/components';

@Component({
	components: {
		cuspreEdit
	}
})
export default class CusPre extends BasePage {
	get table(): TwTable {
		return this.$refs['table'] as TwTable;
	}

	rowGuid = '';
	showEdit = false;
	columns = [];

	searchMode = {
		CUSTOMNAME: ''
	};

	ok() {
		this.table.reload();
	}

	add() {
		this.rowGuid = '';
		this.showEdit = true;
	}

	refresh() {
		this.table.load({...this.searchMode});
	}

	dbClick(row) {
		this.showEdit = true;
		this.rowGuid = row.Guid;
	}

	deleteRows() {
		this.$confirm('此操作将永久删除该数据以及明细, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		})
			.then(() => {
				this.$http
					.post('Basic/CusPre/Delete', {
						GUID: this.table.getSelections().map(item => item.Guid)
					})
					.then(res => {
						if (res.data.status === 0) {
							this.$message.success('删除成功');
							this.table.reload();
						} else {
							this.$message.warning(res.data.msg || '操作失败');
						}
					});
			})
			.catch(() => {
			});
	}

	mounted() {
		this.buildColumn('003003', this.columns);
	}

}
